module.exports={Remove:"Verwijderen"};